import { useState } from "react";
import { formattedTs } from "../utils";

export const Image = ({ showBotAvatar, imageUrl, ts }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="flex space-x-1">
      <div className="flex flex-col space-y-1">
        <div
          className={`ml-4 w-fit min-w-[10%] max-w-[75%] self-start whitespace-pre-line break-words text-sm text-white`}
        >
          {isLoading && <div className="loader">Loading...</div>}
          <img
            className={`rounded-xl shadow-sm cursor-pointer ${isLoading ? 'hidden' : ''}`}
            src={imageUrl}
            alt="imgAlt"
            onClick={togglePopup}
            onLoad={handleImageLoad}
          />
        </div>
        {showBotAvatar && (
          <div className="text-[10px] italic text-gray-500">
            {formattedTs(ts)}
          </div>
        )}
      </div>
      {isPopupVisible && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
          onClick={togglePopup}
        >
          {isLoading && <div className="loader">Loading...</div>}
          <img
            className={`rounded-xl shadow-lg max-w-full max-h-full p-4 ${isLoading ? 'hidden' : ''}`}
            src={imageUrl}
            alt="imgAlt"
            onLoad={handleImageLoad}
          />
        </div>
      )}
    </div>
  );
};